import { memo } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  background-color: #1a9ab7; /* Base color */
  border-radius: 5px;
  padding: 14px 20px;
  outline: 0px;
  cursor: pointer;
  border-width: 0px 5px 5px 0px;
  border-right-color: #1a9ab7;
  border-bottom-color: #1a9ab7;
  width: 100%;

  &:hover {
    background-color: #138295; /* Hover color */
    border-right-color: #138295;
    border-bottom-color: #138295;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #696969;
    border-right-color: #000000;
    border-bottom-color: #000000;

    &:hover {
      background-color: #696969;
    }
  }
`;

const Button = memo(({ children, disabled, ...rest }) => (
  <StyledButton {...rest} disabled={disabled}>
    {children}
  </StyledButton>
));

export default Button;
